var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_2316)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7064 15.7069C12.5188 15.8943 12.2645 15.9996 11.9994 15.9996C11.7342 15.9996 11.4799 15.8943 11.2924 15.7069L5.63537 10.0499C5.53986 9.95761 5.46367 9.84726 5.41126 9.72526C5.35886 9.60326 5.33127 9.47204 5.33012 9.33926C5.32896 9.20648 5.35426 9.0748 5.40454 8.9519C5.45483 8.829 5.52908 8.71735 5.62297 8.62346C5.71686 8.52957 5.82852 8.45531 5.95141 8.40503C6.07431 8.35475 6.20599 8.32945 6.33877 8.3306C6.47155 8.33176 6.60277 8.35934 6.72477 8.41175C6.84677 8.46416 6.95712 8.54034 7.04937 8.63585L11.9994 13.5859L16.9494 8.63585C17.138 8.4537 17.3906 8.3529 17.6528 8.35518C17.915 8.35746 18.1658 8.46263 18.3512 8.64804C18.5366 8.83344 18.6418 9.08426 18.644 9.34645C18.6463 9.60865 18.5455 9.86125 18.3634 10.0499L12.7064 15.7069Z",
    fill: "#E6537E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_2316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/icon-down.62d7506df55e21c3b60ee68177415c10.svg";
export { ForwardRef as ReactComponent };